import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppStore {
  restaurantId: string | null
  onboardingCompleted: boolean
  sidebarCollapsed: boolean
  featureSheAnswers: boolean
  featureCustomerPage: boolean
  featurePOS: boolean
  posMode: 'integrated' | 'standalone' | 'hybrid'
  languageCode: string

  setRestaurantId: (id: string | null) => void
  setOnboardingCompleted: (v: boolean) => void
  toggleSidebar: () => void
  setFeatures: (f: { sheAnswers: boolean; customerPage: boolean; pos: boolean; posMode?: 'integrated' | 'standalone' | 'hybrid' }) => void
  setPOSMode: (mode: 'integrated' | 'standalone' | 'hybrid') => void
  setLanguageCode: (lang: string) => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      restaurantId: null,
      onboardingCompleted: false,
      sidebarCollapsed: false,
      featureSheAnswers: false,
      featureCustomerPage: false,
      featurePOS: false,
      posMode: 'hybrid',
      languageCode: 'en',

      setRestaurantId: (id) => set({ restaurantId: id }),
      setOnboardingCompleted: (v) => set({ onboardingCompleted: v }),
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setFeatures: (f) => set((state) => ({
        featureSheAnswers: f.sheAnswers,
        featureCustomerPage: f.customerPage,
        featurePOS: f.pos,
        posMode: f.posMode ?? state.posMode,
      })),
      setPOSMode: (posMode) => set({ posMode }),
      setLanguageCode: (lang) => set({ languageCode: lang }),
    }),
    {
      name: 'app-store',
      partialize: (state) => ({
        restaurantId: state.restaurantId,
        onboardingCompleted: state.onboardingCompleted,
        sidebarCollapsed: state.sidebarCollapsed,
        featureSheAnswers: state.featureSheAnswers,
        featureCustomerPage: state.featureCustomerPage,
        featurePOS: state.featurePOS,
        posMode: state.posMode,
        languageCode: state.languageCode,
      }),
    },
  ),
)
